<template>
  <main>
    <div class="tw-max-w-[696px] tw-mx-auto">
      <div
        class="lg:tw-flex tw-items-center tw-justify-between tw-mb-8"
        v-if="features"
      >
        <div>
          <h1
            class="tw-font-bold tw-text-xl tw-tracking-[-0.1px] tw-leading-[190%] tw-text-[#1A2139]"
          >
            Which features would you like to use?
          </h1>
          <p class="tw-text-[#4C5B90] tw-font-[450]">
            Choose a combination of tools that help you elevate your company.
          </p>
        </div>
        <span
          class="tw-bg-[#FFEED9] tw-rounded tw-w-[155px] tw-h-[35px] tw-px-6 tw-flex tw-items-center"
        >
          <p
            class="tw-text-[#C06C00] tw-text-[15px] tw-font-medium tw-leading-[150%]"
          >
            {{ myFeatures.length }} of {{ features.length }} Selected
          </p>
        </span>
      </div>
      <form
        @submit.prevent="isClicked = true"
        class="tw-flex tw-flex-wrap tw-justify-between tw-gap-y-6 md:tw-gap-x-8 features"
      >
        <label
          :for="feature.name"
          class="tw-rounded tw-px-8 tw-border tw-border-[#F1F3F699] tw-py-9 tw-w-full md:tw-max-w-[332px] tw-h-[160px] features__card"
          v-for="feature in features"
          :class="[
            organisationDetails.products.includes(feature.category)
              ? 'tw-cursor-not-allowed tw-bg-[#FAFBFF]'
              : 'tw-cursor-pointer tw-bg-[#FFFFFF]',
          ]"
          :key="feature._id"
        >
          <div class="tw-flex tw-items-center tw-justify-between">
            <p
              class="tw-font-bold tw-text-[#1A2139] tw-tracking-[-0.1px] tw-mb-2 tw-capitalize"
            >
              {{ feature.name }}
            </p>
            <input
              type="checkbox"
              :disabled="
                organisationDetails.products.includes(feature.category)
              "
              v-if="feature.status === 'ACTIVE'"
              name="product"
              :checked="organisationDetails.products.includes(feature.category)"
              :value="feature.category"
              :id="feature.name"
              v-model="myFeatures"
            />
          </div>
          <p
            class="tw-text-[#4C5B90] tw-font-[450]"
            v-if="feature.status === 'ACTIVE'"
          >
            {{ feature.description }}
          </p>
          <div
            class="tw-h-[35px] tw-flex tw-items-center tw-justify-center tw-w-[143px] tw-bg-[#FCE9E9] tw-rounded tw-font-medium tw-text-[#C63434] tw-text-xs tw-mt-5"
            v-else
          >
            COMING SOON
          </div>
        </label>
        <p
          class="tw-text-red-error tw-w-full tw-text-right"
          v-if="isClicked && isEmpty"
        >
          Please select a product
        </p>
        <div class="tw-flex tw-w-full tw-gap-x-[22px] tw-justify-end tw-mt-10">
          <router-link :to="{ name: 'OverviewDetails' }">
            <button
              class="tw-h-[56px] tw-w-[155px] tw-text-sm tw-tracking-[-0.12px] tw-text-[#06206B] tw-font-medium tw-bg-[#E6EDFF] tw-rounded"
            >
              Use Default For Now
            </button>
          </router-link>
          <div class="tw-w-[155px]">
            <CustomButton title="Done" />
          </div>
        </div>
        <a
          ref="dueDiligence"
          href="https://airtable.com/shrNQr1FF3Io52cCO"
          target="_blank"
          rel="noopener noreferrer"
        >
        </a>
      </form>
    </div>
  </main>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import CustomButton from "@/components/general/BtnComponent";
  export default {
    name: "FeaturesList",
    data() {
      return {
        myFeatures: [],
        isClicked: false,
      };
    },
    components: {
      CustomButton,
    },
    computed: {
      ...mapGetters("organisationModule", ["features", "organisationDetails"]),

      isEmpty() {
        return this.myFeatures.length < 1;
      },
    },
    created() {
      this.fetchFeatures();
    },
    watch: {
      isClicked(val) {
        if (val && !this.isEmpty) {
          this.addFeature();
        }
      },
      myFeatures() {
        this.isClicked = false;
      },
    },
    methods: {
      ...mapActions("organisationModule", [
        "getFeatures",
        "subscribeToFeature",
        "getOrganisationProfile",
      ]),
      ...mapActions(["showToast"]),
      async fetchFeatures() {
        try {
          await this.getFeatures();
          this.features.forEach((feature) => {
            if (this.organisationDetails.products.includes(feature.category)) {
              this.myFeatures.push(feature.category);
            }
          });
        } catch (error) {
          return error;
        }
      },
      async addFeature() {
        if (this.myFeatures.includes("PUBLIC_RAISE")) {
          this.$refs.dueDiligence.click();
        }
        try {
          const response = await this.subscribeToFeature(this.myFeatures);
          const { message } = response.data;
          this.showToast({
            description: message,
            display: true,
            type: "success",
          });
          this.fetchOrganisationInfo();
        } catch (error) {
          this.isClicked = false;
          return error;
        }
      },
      async fetchOrganisationInfo() {
        try {
          await this.getOrganisationProfile();
          this.$router.push({ name: "OverviewDetails" });
        } catch (error) {
          return error;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .features {
    &__card {
      box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.12);
      /* @media (min-width: 1024px) {
        flex-basis: 30%;
      } */
    }
  }
</style>
